import angular from 'angular';

import PhoneComponent from './phone.component';

const PhoneModule = angular
    .module('control-room.commons.basic.components.phone', [])
    .component('crPhone', PhoneComponent);

export default PhoneModule;
